import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  AreaTitle,
  BottomMessage,
  BottomMessageAccess,
  ButtonDivision,
  ContainerBody,
  HeaderMessage,
} from "./styles";
import success from '~/assets/images/success.svg';
import war from '~/assets/images/warning-yellow.svg';

import { InfoButton } from '~/components/layout/Buttons';

export default function OrderStatusMessage({ analize }) {
  
  const history = useHistory();

  useEffect(()=>{
    window.addEventListener('popstate', function() {
      history.replace('/portal')
    });
  },[])

  return (
    <ContainerBody>
      {!analize ? (
        <>
        <AreaTitle>
          <img src={success} alt="Pedido com sucesso" />
        </AreaTitle>
        <HeaderMessage>
          Pedido recebido com sucesso.
        </HeaderMessage>
        <BottomMessage>
          O boleto para pagamento desse pedido estará disponível após aprovação de crédito.
        </BottomMessage>
        <BottomMessage>
          Você também pode antecipar o pagamento dos boletos já emitidos e liberar o crédito com a Ultragaz.
        </BottomMessage>
        <BottomMessage>
          Acesse Minha Conta {'->'} 2ª via de Boleto
        </BottomMessage>
        <ButtonDivision onClick={() => history.push('/boletos')}>
          <InfoButton style={{ margin: "-1rem 0 1rem 0" }}>
            <div>Antecipar pagamentos</div>
          </InfoButton>
        </ButtonDivision>
        <BottomMessageAccess>
          Para acompanhar o seu pedido, basta consultar o "Status do Pedido" na tela inicial.
        </BottomMessageAccess>
        </>
      ) : (
        <>
        <AreaTitle>
          <img src={war} alt="Análise" />
        </AreaTitle>
        <HeaderMessage>
          Pedido sujeito à análise de crédito.
        </HeaderMessage>
        <BottomMessage>
          Verificamos que o crédito que possui com a Ultragaz atingiu o seu limite.
          Nossos analistas irão analisar o seu pedido e, se o aumento do seu crédito for aprovado, prosseguiremos com o seu abastecimento.
        </BottomMessage>
        <BottomMessage>
          Você também pode antecipar o pagamento dos boletos já emitidos e liberar o crédito com a Ultragaz.
        </BottomMessage>
        <BottomMessage>
          Acesse Minha Conta {'->'} 2ª via de Boleto
        </BottomMessage>
        <ButtonDivision onClick={() => history.push('/boletos')}>
          <InfoButton style={{ margin: "-2rem 0 2rem 0" }}>
            <div>Antecipar pagamentos</div>
          </InfoButton>
        </ButtonDivision>
        <BottomMessageAccess>
          Para acompanhar o seu pedido, basta consultar o "Status do Pedido" na tela inicial.
        </BottomMessageAccess>
        </>
      )}
    </ContainerBody>
  ); 
}
